export default __webpack_public_path__ + "static/media/pic5.fb849e41.jpg";